// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lm_root {
  position: relative;
}
.lm_row > .lm_item {
  float: left;
}
.lm_content {
  overflow: hidden;
  position: relative;
}
.lm_dragging,
.lm_dragging * {
  cursor: move !important;
  -webkit-user-select: none;
          user-select: none;
}
.lm_maximised {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 40;
}
.lm_maximise_placeholder {
  display: none;
}
.lm_splitter {
  position: relative;
  z-index: 2;
  touch-action: none;
}
.lm_splitter.lm_vertical .lm_drag_handle {
  width: 100%;
  position: absolute;
  cursor: ns-resize;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}
.lm_splitter.lm_horizontal {
  float: left;
  height: 100%;
}
.lm_splitter.lm_horizontal .lm_drag_handle {
  height: 100%;
  position: absolute;
  cursor: ew-resize;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}
.lm_header {
  overflow: visible;
  position: relative;
  z-index: 1;
  -webkit-user-select: none;
          user-select: none;
}
.lm_header [class^=lm_] {
  box-sizing: content-box !important;
}
.lm_header .lm_controls {
  position: absolute;
  right: 3px;
  display: flex;
}
.lm_header .lm_controls > * {
  cursor: pointer;
  float: left;
  width: 18px;
  height: 18px;
  text-align: center;
}
.lm_header .lm_tabs {
  position: absolute;
  display: flex;
}
.lm_header .lm_tab {
  cursor: pointer;
  float: left;
  height: 14px;
  margin-top: 1px;
  padding: 0px 10px 5px;
  padding-right: 25px;
  position: relative;
  touch-action: none;
}
.lm_header .lm_tab i {
  width: 2px;
  height: 19px;
  position: absolute;
}
.lm_header .lm_tab i.lm_left {
  top: 0;
  left: -2px;
}
.lm_header .lm_tab i.lm_right {
  top: 0;
  right: -2px;
}
.lm_header .lm_tab .lm_title {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lm_header .lm_tab .lm_close_tab {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
}
.lm_stack {
  position: relative;
}
.lm_stack > .lm_items {
  overflow: hidden;
}
.lm_stack.lm_left > .lm_items {
  position: absolute;
  left: 20px;
  top: 0;
}
.lm_stack.lm_right > .lm_items {
  position: absolute;
  right: 20px;
  top: 0;
}
.lm_stack.lm_right > .lm_header {
  position: absolute;
  right: 0;
  top: 0;
}
.lm_stack.lm_bottom > .lm_items {
  position: absolute;
  bottom: 20px;
}
.lm_stack.lm_bottom > .lm_header {
  position: absolute;
  bottom: 0;
}
.lm_left.lm_stack .lm_header,
.lm_right.lm_stack .lm_header {
  height: 100%;
}
.lm_left.lm_dragProxy .lm_header,
.lm_right.lm_dragProxy .lm_header,
.lm_left.lm_dragProxy .lm_items,
.lm_right.lm_dragProxy .lm_items {
  float: left;
}
.lm_left.lm_dragProxy .lm_header,
.lm_right.lm_dragProxy .lm_header,
.lm_left.lm_stack .lm_header,
.lm_right.lm_stack .lm_header {
  width: 20px;
  vertical-align: top;
}
.lm_left.lm_dragProxy .lm_header .lm_tabs,
.lm_right.lm_dragProxy .lm_header .lm_tabs,
.lm_left.lm_stack .lm_header .lm_tabs,
.lm_right.lm_stack .lm_header .lm_tabs {
  transform-origin: left top;
  top: 0;
  width: 1000px;
  /*hack*/
}
.lm_left.lm_dragProxy .lm_header .lm_controls,
.lm_right.lm_dragProxy .lm_header .lm_controls,
.lm_left.lm_stack .lm_header .lm_controls,
.lm_right.lm_stack .lm_header .lm_controls {
  bottom: 0;
  flex-flow: column;
}
.lm_dragProxy.lm_left .lm_header .lm_tabs,
.lm_stack.lm_left .lm_header .lm_tabs {
  transform: rotate(-90deg) scaleX(-1);
  left: 0;
}
.lm_dragProxy.lm_left .lm_header .lm_tabs .lm_tab,
.lm_stack.lm_left .lm_header .lm_tabs .lm_tab {
  transform: scaleX(-1);
  margin-top: 1px;
}
.lm_dragProxy.lm_left .lm_header .lm_tabdropdown_list,
.lm_stack.lm_left .lm_header .lm_tabdropdown_list {
  top: initial;
  right: initial;
  left: 20px;
}
.lm_dragProxy.lm_right .lm_content {
  float: left;
}
.lm_dragProxy.lm_right .lm_header .lm_tabs,
.lm_stack.lm_right .lm_header .lm_tabs {
  transform: rotate(90deg) scaleX(1);
  left: 100%;
  margin-left: 0;
}
.lm_dragProxy.lm_right .lm_header .lm_controls,
.lm_stack.lm_right .lm_header .lm_controls {
  left: 3px;
}
.lm_dragProxy.lm_right .lm_header .lm_tabdropdown_list,
.lm_stack.lm_right .lm_header .lm_tabdropdown_list {
  top: initial;
  right: 20px;
}
.lm_dragProxy.lm_bottom .lm_header,
.lm_stack.lm_bottom .lm_header {
  width: 100%;
}
.lm_dragProxy.lm_bottom .lm_header .lm_tab,
.lm_stack.lm_bottom .lm_header .lm_tab {
  margin-top: 0;
  border-top: none;
}
.lm_dragProxy.lm_bottom .lm_header .lm_controls,
.lm_stack.lm_bottom .lm_header .lm_controls {
  top: 3px;
}
.lm_dragProxy.lm_bottom .lm_header .lm_tabdropdown_list,
.lm_stack.lm_bottom .lm_header .lm_tabdropdown_list {
  top: initial;
  bottom: 20px;
}
.lm_drop_tab_placeholder {
  float: left;
  width: 100px;
  visibility: hidden;
}
.lm_header .lm_controls .lm_tabdropdown:before {
  content: '';
  width: 0;
  height: 0;
  vertical-align: middle;
  display: inline-block;
  border-top: 5px dashed;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  color: white;
}
.lm_header .lm_tabdropdown_list {
  position: absolute;
  top: 20px;
  right: 0;
  z-index: 5;
  overflow: hidden;
}
.lm_header .lm_tabdropdown_list .lm_tab {
  clear: both;
  padding-right: 10px;
  margin: 0;
}
.lm_header .lm_tabdropdown_list .lm_tab .lm_title {
  width: 100px;
}
.lm_header .lm_tabdropdown_list .lm_close_tab {
  display: none !important;
}
/***********************************
* Drag Proxy
***********************************/
.lm_dragProxy {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 30;
}
.lm_dragProxy .lm_header {
  background: transparent;
}
.lm_dragProxy .lm_content {
  border-top: none;
  overflow: hidden;
}
.lm_dropTargetIndicator {
  display: none;
  position: absolute;
  z-index: 35;
  transition: all 200ms ease;
}
.lm_dropTargetIndicator .lm_inner {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
}
.lm_transition_indicator {
  display: none;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
}
.lm_popin {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9999;
}
.lm_popin > * {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.lm_popin > .lm_bg {
  z-index: 10;
}
.lm_popin > .lm_icon {
  z-index: 20;
}
`, "",{"version":3,"sources":["webpack://./node_modules/golden-layout/dist/css/goldenlayout-base.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;UACjB,iBAAiB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;UACjB,iBAAiB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;UACjB,iBAAiB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;UACjB,iBAAiB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,UAAU;AACZ;AACA;EACE,MAAM;EACN,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,WAAW;AACb;AACA;;;;EAIE,WAAW;EACX,mBAAmB;AACrB;AACA;;;;EAIE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,OAAO;AACT;AACA;;;;EAIE,SAAS;EACT,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;EACpC,OAAO;AACT;AACA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;EAEE,kCAAkC;EAClC,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,QAAQ;AACV;AACA;;EAEE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb","sourcesContent":[".lm_root {\n  position: relative;\n}\n.lm_row > .lm_item {\n  float: left;\n}\n.lm_content {\n  overflow: hidden;\n  position: relative;\n}\n.lm_dragging,\n.lm_dragging * {\n  cursor: move !important;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.lm_maximised {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 40;\n}\n.lm_maximise_placeholder {\n  display: none;\n}\n.lm_splitter {\n  position: relative;\n  z-index: 2;\n  touch-action: none;\n}\n.lm_splitter.lm_vertical .lm_drag_handle {\n  width: 100%;\n  position: absolute;\n  cursor: ns-resize;\n  touch-action: none;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.lm_splitter.lm_horizontal {\n  float: left;\n  height: 100%;\n}\n.lm_splitter.lm_horizontal .lm_drag_handle {\n  height: 100%;\n  position: absolute;\n  cursor: ew-resize;\n  touch-action: none;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.lm_header {\n  overflow: visible;\n  position: relative;\n  z-index: 1;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.lm_header [class^=lm_] {\n  box-sizing: content-box !important;\n}\n.lm_header .lm_controls {\n  position: absolute;\n  right: 3px;\n  display: flex;\n}\n.lm_header .lm_controls > * {\n  cursor: pointer;\n  float: left;\n  width: 18px;\n  height: 18px;\n  text-align: center;\n}\n.lm_header .lm_tabs {\n  position: absolute;\n  display: flex;\n}\n.lm_header .lm_tab {\n  cursor: pointer;\n  float: left;\n  height: 14px;\n  margin-top: 1px;\n  padding: 0px 10px 5px;\n  padding-right: 25px;\n  position: relative;\n  touch-action: none;\n}\n.lm_header .lm_tab i {\n  width: 2px;\n  height: 19px;\n  position: absolute;\n}\n.lm_header .lm_tab i.lm_left {\n  top: 0;\n  left: -2px;\n}\n.lm_header .lm_tab i.lm_right {\n  top: 0;\n  right: -2px;\n}\n.lm_header .lm_tab .lm_title {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.lm_header .lm_tab .lm_close_tab {\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  text-align: center;\n}\n.lm_stack {\n  position: relative;\n}\n.lm_stack > .lm_items {\n  overflow: hidden;\n}\n.lm_stack.lm_left > .lm_items {\n  position: absolute;\n  left: 20px;\n  top: 0;\n}\n.lm_stack.lm_right > .lm_items {\n  position: absolute;\n  right: 20px;\n  top: 0;\n}\n.lm_stack.lm_right > .lm_header {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.lm_stack.lm_bottom > .lm_items {\n  position: absolute;\n  bottom: 20px;\n}\n.lm_stack.lm_bottom > .lm_header {\n  position: absolute;\n  bottom: 0;\n}\n.lm_left.lm_stack .lm_header,\n.lm_right.lm_stack .lm_header {\n  height: 100%;\n}\n.lm_left.lm_dragProxy .lm_header,\n.lm_right.lm_dragProxy .lm_header,\n.lm_left.lm_dragProxy .lm_items,\n.lm_right.lm_dragProxy .lm_items {\n  float: left;\n}\n.lm_left.lm_dragProxy .lm_header,\n.lm_right.lm_dragProxy .lm_header,\n.lm_left.lm_stack .lm_header,\n.lm_right.lm_stack .lm_header {\n  width: 20px;\n  vertical-align: top;\n}\n.lm_left.lm_dragProxy .lm_header .lm_tabs,\n.lm_right.lm_dragProxy .lm_header .lm_tabs,\n.lm_left.lm_stack .lm_header .lm_tabs,\n.lm_right.lm_stack .lm_header .lm_tabs {\n  transform-origin: left top;\n  top: 0;\n  width: 1000px;\n  /*hack*/\n}\n.lm_left.lm_dragProxy .lm_header .lm_controls,\n.lm_right.lm_dragProxy .lm_header .lm_controls,\n.lm_left.lm_stack .lm_header .lm_controls,\n.lm_right.lm_stack .lm_header .lm_controls {\n  bottom: 0;\n  flex-flow: column;\n}\n.lm_dragProxy.lm_left .lm_header .lm_tabs,\n.lm_stack.lm_left .lm_header .lm_tabs {\n  transform: rotate(-90deg) scaleX(-1);\n  left: 0;\n}\n.lm_dragProxy.lm_left .lm_header .lm_tabs .lm_tab,\n.lm_stack.lm_left .lm_header .lm_tabs .lm_tab {\n  transform: scaleX(-1);\n  margin-top: 1px;\n}\n.lm_dragProxy.lm_left .lm_header .lm_tabdropdown_list,\n.lm_stack.lm_left .lm_header .lm_tabdropdown_list {\n  top: initial;\n  right: initial;\n  left: 20px;\n}\n.lm_dragProxy.lm_right .lm_content {\n  float: left;\n}\n.lm_dragProxy.lm_right .lm_header .lm_tabs,\n.lm_stack.lm_right .lm_header .lm_tabs {\n  transform: rotate(90deg) scaleX(1);\n  left: 100%;\n  margin-left: 0;\n}\n.lm_dragProxy.lm_right .lm_header .lm_controls,\n.lm_stack.lm_right .lm_header .lm_controls {\n  left: 3px;\n}\n.lm_dragProxy.lm_right .lm_header .lm_tabdropdown_list,\n.lm_stack.lm_right .lm_header .lm_tabdropdown_list {\n  top: initial;\n  right: 20px;\n}\n.lm_dragProxy.lm_bottom .lm_header,\n.lm_stack.lm_bottom .lm_header {\n  width: 100%;\n}\n.lm_dragProxy.lm_bottom .lm_header .lm_tab,\n.lm_stack.lm_bottom .lm_header .lm_tab {\n  margin-top: 0;\n  border-top: none;\n}\n.lm_dragProxy.lm_bottom .lm_header .lm_controls,\n.lm_stack.lm_bottom .lm_header .lm_controls {\n  top: 3px;\n}\n.lm_dragProxy.lm_bottom .lm_header .lm_tabdropdown_list,\n.lm_stack.lm_bottom .lm_header .lm_tabdropdown_list {\n  top: initial;\n  bottom: 20px;\n}\n.lm_drop_tab_placeholder {\n  float: left;\n  width: 100px;\n  visibility: hidden;\n}\n.lm_header .lm_controls .lm_tabdropdown:before {\n  content: '';\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  display: inline-block;\n  border-top: 5px dashed;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  color: white;\n}\n.lm_header .lm_tabdropdown_list {\n  position: absolute;\n  top: 20px;\n  right: 0;\n  z-index: 5;\n  overflow: hidden;\n}\n.lm_header .lm_tabdropdown_list .lm_tab {\n  clear: both;\n  padding-right: 10px;\n  margin: 0;\n}\n.lm_header .lm_tabdropdown_list .lm_tab .lm_title {\n  width: 100px;\n}\n.lm_header .lm_tabdropdown_list .lm_close_tab {\n  display: none !important;\n}\n/***********************************\n* Drag Proxy\n***********************************/\n.lm_dragProxy {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 30;\n}\n.lm_dragProxy .lm_header {\n  background: transparent;\n}\n.lm_dragProxy .lm_content {\n  border-top: none;\n  overflow: hidden;\n}\n.lm_dropTargetIndicator {\n  display: none;\n  position: absolute;\n  z-index: 35;\n  transition: all 200ms ease;\n}\n.lm_dropTargetIndicator .lm_inner {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n.lm_transition_indicator {\n  display: none;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 20;\n}\n.lm_popin {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: 9999;\n}\n.lm_popin > * {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.lm_popin > .lm_bg {\n  z-index: 10;\n}\n.lm_popin > .lm_icon {\n  z-index: 20;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
